import Operation from "../index.js";

export default {
    //获取登录信息
    getClassData(id, time, fn) {
        Operation.Http.post(`/tencent/getClassData?scheduleId=${id}${time? '&time=true' : ''}`, null, fn)
    },
    findUserNameById(id, fn) {
        Operation.Http.post(`/tencent/findUserNameById?userId=${id}`, null, fn)
    },
    checkScheduleTime(id, fn) {
        Operation.Http.post(`/tencent/checkScheduleTime?scheduleId=${id}`, null, fn)
    },
}


// WEBPACK FOOTER //
// ./src/request/api/tencent.js